var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 11.9759H14.71L14.43 11.7449C15.41 10.7698 16 9.50377 16 8.12656C16 5.05564 13.09 2.56641 9.5 2.56641C5.91 2.56641 3 5.05564 3 8.12656C3 11.1975 5.91 13.6867 9.5 13.6867C11.11 13.6867 12.59 13.182 13.73 12.3437L14 12.5832V13.259L19 17.5275L20.49 16.2529L15.5 11.9759ZM9.5 11.9759C7.01 11.9759 5 10.2565 5 8.12656C5 5.99659 7.01 4.27722 9.5 4.27722C11.99 4.27722 14 5.99659 14 8.12656C14 10.2565 11.99 11.9759 9.5 11.9759Z",
    fill: "#13214E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b8f12767737c02b8eb475b5d8b5f8fec.svg";
export { ForwardRef as ReactComponent };